import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as subaward from '../subaward'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subaward.RESOURCE.payload.dimension.partialId,
      partialId: subaward.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Amount being distributed over the current budget period',
    isOptional: true,
    name: 'Amount Funded This Action',
    partialId: PartialId.Standard.create('curr_amount'),
    type: core.common.value.types.Intrinsic.Currency,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
